import { paginationSchema } from '@snap-types/models/pagination';
import { z } from 'zod/v4';

export const configuratorFieldOptionsQuerySchema = z
  .object({
    q: z.string().optional(),
    params: z
      .object({
        productCodes: z.array(z.string()).default([]),
        serviceId: z.string().optional(),
      })
      .default({
        productCodes: [],
      }),
  })
  .extend(paginationSchema.shape);

export type ConfiguratorFieldOptionsQuery = z.infer<
  typeof configuratorFieldOptionsQuerySchema
>;

export const ConfiguratorSnapshotGetManyQuery = paginationSchema;

export type ConfiguratorSnapshotGetManyQuery = z.infer<
  typeof ConfiguratorSnapshotGetManyQuery
>;

export const ConfiguratorSnapshotSearchQuery =
  ConfiguratorSnapshotGetManyQuery.extend({
    search: z.string().optional(),
    site: z.string().optional(),
  });
export type ConfiguratorSnapshotSearchQuery = z.infer<
  typeof ConfiguratorSnapshotSearchQuery
>;
